<template>
  <div>
    <b-modal
      ref="add-product"
      :visible="showModal"
      :title="$t('modals.add_product')"
      centered
      size="lg"
      :ok-title="$t('actions.submit')"
      :cancel-title="$t('actions.cancel')"
      @ok="manageProduct"
      @hidden="closeModal"
    >
      <b-row>
        <b-col class="mb-3 d-flex align-items-center">
          {{ $t("field.product") }}:
          <multi-select
            v-model="product"
            :multiple="false"
            :options="products"
            :allow-empty="false"
            :searchable="true"
            :placeholder="$t('actions.pick_product')"
            :show-labels="false"
            :custom-label="getSapName"
            label="name"
            track-by="id"
            class="ml-2"
            @input="selectProduct"
          >
            <span slot="noOptions">{{ $t("messages.no_results") }}</span>
            <span slot="noResult">{{ $t("messages.no_results") }}</span>
          </multi-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :label="$t('field.sap_code')">
            <b-form-input v-model="product.sap_code" name="sap_code" disabled />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.aim_code')">
            <b-form-input v-model="product.aim_code" name="aim_code" disabled />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.chnm_code')">
            <b-form-input v-model="product.chnm_code" name="chnm_code" disabled />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.spms_code')">
            <b-form-input
              v-model="product.spms_code"
              name="spms_code"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :label="$t('field.name')">
            <b-form-input v-model="product.name" name="name" disabled />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.commercial_name')">
            <b-form-input
              v-model="product.commercial_name"
              name="commercial_name"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :label="$t('field.dosage')">
            <b-form-input v-model="product.dosage" name="dosage" disabled />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.dosage_form')">
            <b-form-input
              v-model="product.dosage_form"
              name="dosage_form"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :label="$t('field.presentation')">
            <b-form-input
              v-model="product.presentation"
              name="presentation"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.conservation_conditions')">
            <b-form-input
              v-model="product.conservation_conditions"
              name="conservation_conditions"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :label="$t('field.classification')">
            <b-form-input
              v-model="product.classification"
              name="classification"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.tax')">
            <b-form-input v-model="tax.label" name="tax" disabled />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :label="$t('field.authorization_date')">
            <b-form-input
              v-model="product.authorization_date"
              name="authorization_date"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.marketing_date')">
            <b-form-input
              v-model="product.marketing_date"
              name="marketing_date"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <b-form-checkbox
              v-model="product.is_generic_drug"
              switch
              disabled
              class="mb-3"
            >
              {{ $t("field.is_generic_drug") }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <b-form-checkbox
              v-model="product.is_marketed"
              disabled
              switch
              class="mb-3"
            >
              {{ $t("field.is_marketed") }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :label="$t('field.license')">
            <b-form-input v-model="product.license" name="license" disabled />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.taim')">
            <b-form-input v-model="product.taim" name="taim" disabled />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :label="$t('field.position')">
            <b-form-input
              v-model="position"
              name="position"
              type="text"
              placeholder="1"
              required
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.batch')">
            <b-form-input
              v-model="batch"
              name="batch"
              type="text"
              placeholder="LT01"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :label="$t('field.entity_code')">
            <b-form-input
              v-model="entity_code"
              name="entity_code"
              type="text"
              placeholder="12345"
              required
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.client_code')">
            <b-form-input
              v-model="client_code"
              name="client_code"
              type="text"
              placeholder="12345"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-inline-flex">
          <b-form-group :label="$t('field.quantity_per_package')">
            <b-form-input
              v-model="$v.quantity_per_package.$model"
              :class="{
                'border border-danger': $v.quantity_per_package.$error,
              }"
              name="quantity_per_package"
              type="number"
              required
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :label="$t('field.price_unit')">
            <b-input-group append="€">
              <b-form-input
                v-model="price_unit"
                name="price_unit"
                type="number"
                @input="priceUnitChange"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.quantity')">
            <b-form-input
              v-model="quantity"
              name="quantity"
              type="number"
              required
              @input="quantityChange"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.price_package')">
            <b-input-group append="€">
              <b-form-input
                v-model="$v.price_package.$model"
                :class="{
                  'border border-danger': $v.price_package.$error,
                }"
                type="number"
                name="price_package"
                required
                @input="pricePackageChange"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.quantity_package')">
            <b-form-input
              v-model="$v.quantity_package.$model"
              :class="{ 'border border-danger': $v.quantity_package.$error }"
              name="quantity_package"
              type="number"
              required
              @input="quantityPackageChange"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :label="$t('field.commercial_discount')">
            <b-input-group append="%">
              <b-form-input
                v-model="$v.commercial_discount.$model"
                :class="{
                  'border border-danger': $v.commercial_discount.$error,
                }"
                type="number"
                name="commercial_discount"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('field.total')">
            <b-form-input
              v-model="totalPrice"
              name="total_price"
              type="number"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group :label="$t('field.observations')">
        <b-form-textarea
          v-model="observations"
          name="observations"
          type="text"
          no-resize
        />
      </b-form-group>
      <editor
        :inputField="other_fields"
        :fieldName="$t('field.other_fields')"
        @updateInput="updateOtherFields"
        :disableProposal="disableProposal"
      />
    </b-modal>
  </div>
</template>

<script>
import { required, minValue, maxValue } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import taxesApi from '@/api/taxes'
import MultiSelect from 'vue-multiselect'
import {
  dosageFormOptions,
  classificationDrugOptions
} from '@/constants/options'
import productsApi from '@/api/products'
import editor from '@/components/common/editor'

export default {
  components: {
    MultiSelect,
    editor
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    editProduct: {
      type: Array,
      required: false,
      default: () => []
    },
    disableProposal: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    async editProduct(product) {
      if (product) {
        this.product.pivot = []
        this.product = product[0]
        this.position = this.product.position
        this.batch = this.product.batch
        this.entity_code = this.product.entity_code
        this.client_code = this.product.client_code
        this.commercial_discount = this.product.commercial_discount
          ? this.product.commercial_discount * 100
          : ''
        this.quantity = this.product.quantity
        this.quantity_package = this.product.quantity_package
        this.quantity_per_package = this.product.quantity_per_package
        this.other_fields = this.product.other_fields
        this.observations = this.product.observations
        this.quantity_package = this.product.quantity_package
        await this.init()
        this.selectProduct()
      }
    }
  },
  data: () => ({
    productsApi,
    dosageFormOptions,
    classificationDrugOptions,
    taxesApi,
    taxes: [],
    tax: [],
    products: [],
    product: [],
    position: null,
    batch: null,
    price_package: null,
    price_unit: null,
    quantity_per_package: null,
    entity_code: null,
    client_code: null,
    quantity: null,
    quantity_package: null,
    commercial_discount: null,
    other_fields: null,
    observations: null
  }),
  computed: {
    ...mapGetters({
      item: 'form/fields'
    }),
    totalPrice() {
      return +parseFloat(
        this.price_package *
          Number(this.quantity_package) *
          (1 - this.commercial_discount / 100)
      ).toFixed(2)
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      await Promise.all([this.getProducts(), this.getTaxes()])
    },
    async getProducts() {
      const response = await this.productsApi.all()

      if (response && response.data && response.data.list) {
        this.products = response.data.list
      } else {
        this.$toasted.error(this.$t('messages.unknown_error'))
      }
    },
    async getTaxes() {
      try {
        const response = await this.taxesApi.all()

        if (response && response.data && response.data.list) {
          this.taxes = response.data.list.map(item => ({
            id: item.id,
            label: this.formatPercentageWithSymbol(item.value)
          }))
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        console.error(e)
      }
    },
    selectProduct() {
      this.price_unit = this.product.price_unit
      this.quantity_per_package = this.product.quantity_per_package
      this.setTax()
      this.calculatePackagePrice()
      this.calculatePackagesNumber()
      this.calculateUnitsQuantity()
    },
    setTax() {
      this.tax = this.taxes.find(item => item.id === this.product.tax_id)
    },
    formatPercentageWithSymbol(value) {
      return Math.round(value * Math.pow(10, 3) * 100) / Math.pow(10, 3) + '%'
    },
    closeModal() {
      this.product = []
      this.$v.$reset()
      this.position = null
      this.batch = null
      this.price_unit = null
      this.price_package = null
      this.entity_code = null
      this.client_code = null
      this.quantity = null
      this.quantity_package = null
      this.other_fields = null
      this.observations = null
      this.commercial_discount = null
      this.$emit('close')
    },
    updateOtherFields(text) {
      this.other_fields = text
    },
    async manageProduct(bvModalEvt) {
      this.$v.$touch()

      this.product.price_unit = this.price_unit
        ? Number(this.price_unit)
        : this.product.price_unit
      this.product.price_package = parseFloat(this.price_package)

      const product = {
        ...this.product,
        product_id: this.product.id,
        id: this.product.id,
        tax: this.tax.label,
        position: this.position,
        batch: this.batch,
        price_unit: Number(this.product.price_unit),
        price_package: Number(this.product.price_package),
        entity_code: this.entity_code,
        client_code: this.client_code,
        quantity: Number(this.quantity),
        quantity_package: Number(this.quantity_package),
        commercial_discount: parseInt(this.commercial_discount) / 100,
        designation:
          this.product.commercial_name +
          ' ' +
          this.product.dosage +
          ' ' +
          this.product.dosage_form,
        total_price: Number(this.totalPrice),
        other_fields: this.other_fields,
        observations: this.observations
      }

      if (this.$v.$invalid || !this.product.id) {
        bvModalEvt.preventDefault()
        this.$toasted.error(this.$t('form.error'))
        return
      } else {
        if (this.editProduct && this.editProduct.length > 0) {
          this.$emit('editProduct', product)
        } else {
          this.$emit('addProduct', product)
        }
      }

      await this.getProducts()
    },
    getSapName(data, field) {
      return `${data.sap_code} – ${data[field]}`
    },
    calculatePackagesNumber() {
      if (
        this.quantity_per_package &&
        this.quantity_per_package !== 0 &&
        this.quantity &&
        this.quantity !== 0
      ) {
        this.quantity_package = Math.floor(
          Number(this.quantity) / Number(this.quantity_per_package)
        )
      }
    },
    calculatePackagePrice() {
      if (
        this.price_unit &&
        this.price_unit !== 0 &&
        this.quantity_per_package &&
        this.quantity_per_package !== 0
      ) {
        this.price_package = +parseFloat(
          Number(this.price_unit) * Number(this.quantity_per_package)
        ).toFixed(2)
      }
    },
    calculateUnitsQuantity() {
      if (
        this.quantity_package &&
        this.quantity_package !== 0 &&
        this.quantity_per_package &&
        this.quantity_per_package !== 0
      ) {
        this.quantity =
          Number(this.quantity_per_package) * Number(this.quantity_package)
      }
    },
    calculateUnitPrice() {
      if (
        this.price_package &&
        this.price_package !== 0 &&
        this.quantity_per_package &&
        this.quantity_per_package !== 0
      ) {
        this.price_unit = +parseFloat(
          Number(this.price_package) / Number(this.quantity_per_package)
        ).toFixed(2)
      }
    },
    priceUnitChange() {
      this.calculatePackagePrice()
    },
    pricePackageChange() {
      this.calculateUnitPrice()
    },
    quantityChange() {
      this.calculatePackagesNumber()
    },
    quantityPackageChange() {
      this.calculateUnitsQuantity()
    }
  },
  validations: {
    price_package: {
      required,
      minValue: minValue(0)
    },
    quantity_package: {
      required,
      minValue: minValue(0)
    },
    commercial_discount: {
      maxValue: maxValue(100),
      minValue: minValue(0)
    },
    quantity_per_package: {
      required,
      minValue: minValue(0)
    }
  }
}
</script>
